<template>
  <div :style="{
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: color,
    borderRadius: '10%',
  }">
  </div>
</template>

<script>
export default {
  name: "ColorIndicator",
  props: {
    size: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      required: true
    }
  }
};
</script>

